import type { ExternalAgeVerificationProps } from "@ui/components/HardAgeVerificationPopup/components";
import { ExternalAgeVerification } from "@ui/components/HardAgeVerificationPopup/components";

import type { QrAgeVerificationProps } from "../QrAgeVerification/QrAgeVerification";
import { QrAgeVerification } from "../QrAgeVerification/QrAgeVerification";

export type AgeVerificationContainerProps = { isPassVerification?: boolean } & QrAgeVerificationProps &
  ExternalAgeVerificationProps;

export const AgeVerificationContainer: React.FC<AgeVerificationContainerProps> = ({
  isLoading,
  isOverlay,
  isPortable,
  isPassVerification,
  getNewCode,
  qrCodeValue,
  mobileQrHelper,
  getNewQrButtonLabel,
  errorMessage,
  verificationSteps,
  verificationTitle,
  verificationErrorHelperText,
  verificationErrorMessage,
  verificationHelperText,
}) => {
  if (isPassVerification) {
    return (
      <ExternalAgeVerification
        isOverlay={isOverlay}
        isError={!!errorMessage}
        verificationSteps={verificationSteps}
        verificationTitle={verificationTitle}
        verificationHelperText={verificationHelperText}
        verificationErrorMessage={verificationErrorMessage}
        verificationErrorHelperText={verificationErrorHelperText}
      />
    );
  }

  return (
    <QrAgeVerification
      isOverlay={isOverlay}
      isPortable={isPortable}
      verificationTitle={verificationTitle}
      verificationSteps={verificationSteps}
      mobileQrHelper={mobileQrHelper}
      getNewQrButtonLabel={getNewQrButtonLabel}
      getNewCode={getNewCode}
      isLoading={isLoading}
      qrCodeValue={qrCodeValue}
      errorMessage={errorMessage}
    />
  );
};
